import React from 'react'
import styles from './showcaseTime.module.css';
import { WatchIcon } from '../../../../../Components/Icons/watchIcon';

export const ShowcaseTime = ({ timeStamp }: { timeStamp: string }) => {
    return (
        <div className={styles.showcaseTime}>
            <WatchIcon />
            <span className={styles.timeStamp}>Pivoted at {timeStamp}</span>
        </div>
    )
}
